import { defineComponent as _defineComponent } from 'vue'
import { getAccountPrivilege, editAccountPrivilege } from '@/api/setting/edit-account';
import { findNowMenu, useUser } from '@/pinia/modules/userData';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountAuthority',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: number;
};


const user = useUser();
const is_loading = ref(false);
const user_info = ref<{
  id: number;
  name: string;
  privilege: number[];
}>({} as any);
const loading = ref(false);
const nodeChecks = ref<number[]>([]);
//[-1]为超级管理员 []为普通用户
const isAdmin = ref<number[]>([]);

async function query(id) {
  //  await getStaff(id)

  const res = await (await getAccountPrivilege(id)).data;
  if (res) {
    // const privilege = res.privilege.split(',').map((item) => Number(item)).filter(Boolean);
    // if(privilege.includes(-1)){
    //   isAdmin.value = [-1];
    // }
    // nodeChecks.value = privilege.filter((item) => item !== -1);
    const allMenu = useUser().allMenu;

    const privilege = res.privilege
      .split(',')
      .map(item => Number(item))
      .filter(Boolean);
    console.log(privilege);
    console.log(allMenu);

    const filterPri = privilege.filter(id => {
      return findNowMenu(allMenu, menu => id == menu.id && menu.is_menu === 0);
    });
    console.log(filterPri);

    if (privilege.includes(-1)) {
      isAdmin.value = [-1];
    }
    nodeChecks.value = filterPri.filter(item => item !== -1);
  }
}
function save() {
  const allMenu = useUser().allMenu;
  const leafNode = [...nodeChecks.value].filter(id => {
    return findNowMenu(allMenu, menu => id == menu.id && menu.is_menu === 0);
  });
  const privilege = [...leafNode, ...isAdmin.value].sort().join(',');
  loading.value = true;
  editAccountPrivilege(props.id, privilege).then(() => {
    loading.value = false;
  });
}
watch(
  () => props.id,
  id => {
    if (!id) return;
    query(id);
  },
  {
    immediate: true,
  }
);

return { __sfc: true,props, user, is_loading, user_info, loading, nodeChecks, isAdmin, query, save }
}

})